// extracted by mini-css-extract-plugin
export default {"wrapper":"FlagImageHighlights_wrapper__hmyTL","clickable":"FlagImageHighlights_clickable__pNZLm"};